<template>
    <div class="share-button">
        <b-button
            v-b-tooltip.hover
            size="lg"
            variant="icon"
            :title="$translate('share')"
            class="share-toggle"
            @click="toggleShareDialog"
        >
            <share-icon />
        </b-button>

        <div
            ref="shareDialog"
            class="dialog share-dialog"
            :class="{ 'dialog-opened': shareDialogOpened }"
        >
            <div class="align-items-center noselect">
                <span class="px-4 py-3 text-size-15">
                    {{ $translate('share') }}
                </span>

                <b-button
                    class="py-0 px-2 mr-3 dark ml-auto mb-4"
                    variant="transparent"
                    @click="toggleShareDialog"
                >
                    <i class="fa fa-close" />
                </b-button>
            </div>

            <b-form class="display-flex column p-4 w-100">
                <b-form-input
                    id="input-email"
                    v-model="shareEmail"
                    type="email"
                    class="dialog-input mb-3"
                    required
                    :placeholder="$translate('email')"
                />

                <textarea
                    v-model="shareMessage"
                    maxlength="280"
                    contenteditable="true"
                    :placeholder="$translate('message')"
                    class="
                        share-message-container
                        dialog-input
                        w-100
                        cursor_text
                        px-2
                        p-1
                        text-dark
                    "
                />

                <div class="w-100 align-items-center mt-3">
                    <b-button class="dark pl-0" variant="transparent" @click="copyLink">
                        <i class="fa fa-link mr-1 fa-rotate-90" />
                        {{ $translate('copy_link') }}
                    </b-button>

                    <b-button class="ml-auto px-4 dark h-100" variant="primary" @click="share">
                        {{ $translate('send') }}
                    </b-button>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import UIUtils from '../../business/utils/UIUtils'
import ShareIcon from './partials/icons/ShareIcon'

const AUTO_HIDE_DELAY = 3000

export default {
    name: 'ShareButton',
    components: { ShareIcon },
    data: () => ({
        confirmationIsVisible: false,
        shareEmail: '',
        shareMessage: ''
    }),
    computed: {
        ...mapState({
            shareDialogOpened: state => state.timelapse.shareDialogOpened
        })
    },
    watch: {
        $route() {
            this.$store.commit('timelapse/shareDialogOpened', false)
        }
    },
    methods: {
        share() {
            this.$mainController.share(this.shareEmail, this.shareMessage, window.location.href)

            this.toggleShareDialog()
        },
        async copyLink() {
            if (this.confirmationIsVisible) return

            await UIUtils.copyToClipboard(window.location.href)

            this.confirmationIsVisible = true
            setTimeout(() => {
                this.confirmationIsVisible = false
            }, AUTO_HIDE_DELAY)
        },
        toggleShareDialog() {
            if (!this.shareDialogOpened)
                this.$store.commit('timelapse/shareToPatientDialogOpened', false)

            this.$store.commit('timelapse/shareDialogOpened', !this.shareDialogOpened)
        }
    }
}
</script>

<style lang="scss" scoped>
.share-button {
    position: relative;

    .share-toggle {
        height: 100%;
        width: 100%;
    }

    .share-dialog {
        width: 25rem;
        top: #{$sub-header-height + 0.2};
        right: -0.1rem;
        display: flex;
        flex-direction: column;

        .share-message-container {
            height: 6rem;
            border: $border-narrow-dark;
            color: $dark-5 !important;
            border-color: $dark;
            background-color: transparent;
            box-shadow: none;

            &:focus {
                background-color: transparent;
                border-color: $blue;
                color: $light-2;
                box-shadow: 0 0 0 0.05rem inset $blue;
            }
        }
    }
}
</style>

<style lang="scss">
.share-button {
    .share-dialog {
        input {
            color: $dark-5 !important;
        }
    }
}
</style>
